'use strict'
Object.defineProperty(exports, '__esModule', { value: true })
var isNil_1 = require('./isNil')
function isObject(value) {
  var type = typeof value
  return !isNil_1.default(value) && ['object', 'function'].includes(type)
}
exports.default = isObject
